var map = {
	"./about.webp": 1821,
	"./awards-winner.webp": 1333,
	"./awards.webp": 1334,
	"./bb-most-common.webp": 1822,
	"./bb-price.webp": 1823,
	"./bb-terms.webp": 1824,
	"./cb-statement.webp": 1825,
	"./current-account.webp": 1826,
	"./general-banking.webp": 1827,
	"./generic-quickstart.webp": 1828,
	"./guides-bg.webp": 1634,
	"./insurance-life-buoy.webp": 1829,
	"./insurance-piggy.webp": 1830,
	"./insurance-umbrella.webp": 1831,
	"./jumbo.webp": 1335,
	"./kettle.webp": 1832,
	"./lightbulbs.webp": 1833,
	"./location.webp": 1834,
	"./mortgage-questions.webp": 1835,
	"./mortgages.webp": 1271,
	"./nav-cta/banking.webp": 1574,
	"./nav-cta/broadband.webp": 1575,
	"./nav-cta/energy.webp": 1576,
	"./nav-cta/insurance.webp": 1577,
	"./nav-cta/latest-news.webp": 1578,
	"./nav-cta/mortgages.webp": 1579,
	"./podcast-bg.webp": 1580,
	"./podcast-image.webp": 1581,
	"./podcast.webp": 1582,
	"./stats.webp": 1613,
	"./tips-for-households.webp": 1836
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1820;